<template>
  <div class="cb-baseWelcomePanel hideMobile">
    <div class="container">
      <div class="inner">
        <div class="image">
          <slot name="image"> </slot>
        </div>
        <div class="text">
          <p class="preamble">
            <slot name="header"></slot>
            <slot name="subHeader"></slot>
            <slot name="content"></slot>
            <slot name="buttons">
              <BasePrimaryButton @click.native="$emit('click')">
                {{ buttonText }}
              </BasePrimaryButton>
            </slot>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BasePrimaryButton from "@web-components/components/BasePrimaryButton";
export default {
  components: {
    BasePrimaryButton,
  },
  props: {
    buttonText: {
      type: String,
      required: true,
    },
  },
  inheritAttrs: false,
};
</script>

<style lang="scss">
@import "~@web-components/scss/components/_baseWelcomePanel.scss";
</style>
